import { EmpresaService } from './../services/empresa/empresa.service';
import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { RelatorioService } from "./../services/relatorio/relatorio.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { isNgTemplate } from '@angular/compiler';

@Component({
  selector: 'app-relatorio-arquivos-por-empresa',
  templateUrl: './relatorio-arquivos-por-empresa.component.html',
  styleUrls: ['./relatorio-arquivos-por-empresa.component.scss']
})
export class RelatorioArquivosPorEmpresaComponent implements OnInit {

  public loading = true;

  public listaArquivos:Array<any> = [];

  public empresas: Array<any> = [];

  public lastResponse: any = null

  public perPage:number = 50

  public currentPage:number = 1

  public filter: FormGroup = this.fb.group({
      empresa: new FormControl('', []),
  });

  public dropdownSettingsEmpresas = {
    singleSelection: false,
    idField: 'descricao',
    textField: 'descricao',
    itemsShowLimit: 8,
    selectAllText: 'Marcar todas',
    unSelectAllText: 'Desmarcar todas',
    allowSearchFilter: true
  };

  constructor(
      private _notify: SnotifyService,
      private relatorioService: RelatorioService,
      private empresaService: EmpresaService,
      private fb: FormBuilder
  )  {
  }

  ngOnInit() {
      this._listarEmpresas();
      this.loadData();
  }

  public loadData() {
    this.loading = true;
    this.relatorioService.listarArquivosPorEmpresa(this.getFilters(), this.currentPage, this.perPage).subscribe(
        ({data}:any) => {
            this.loading = false
            this.lastResponse = data;
            this.listaArquivos = this.listaArquivos.concat(this.lastResponse.arquivos.data)

            console.log(this.listaArquivos);
        },
        error => {
            this.loading = false
            this._notify.error("Ocorreu um erro ao carregar os dados")
        }
    )
  }

  public loadPerPage($event) {
      this.perPage = $event.target.value
      this.reset(false)
      this.loadData()
  }

  public reset(reload: boolean): void {
      this.listaArquivos = []
      this.currentPage = 1

      if(reload) {
        Object.keys(this.filter.controls).forEach(key => {
          this.filter.controls[key].setValue(null);
        });

        this.loadData();
      }
  }

  public loadMore():void {
      this.currentPage++;
      this.loadData()
  }

  public toFilter() {
    this.reset(false);
    this.loadData();
  }

  public getFilters() {
    const filter = {};

    Object.keys(this.filter.controls).forEach((_filter) => {
      filter[_filter] = this.filter.controls[_filter].value;
    });

    if (filter['empresa']) {
            filter['empresa'] = filter['empresa'].map(estados => {
          return estados.descricao;
      });
    }

    return filter;
  }

  private _listarEmpresas(): void  {
    this.empresaService.listar(null, '', 'todos')
    .subscribe(
        ({data}) => {

          let flags = [], output = [];
          for( let i=0; i< data.empresas.length; i++) {
            if( flags[data.empresas[i].apelido]) continue;
            flags[data.empresas[i].apelido] = true;

            if(data.empresas[i].apelido != null) {
              output.push({descricao: data.empresas[i].apelido});
            }
          }

          this.empresas = output;

        },
        error => {
          this._notify.warning('Ocorreu um erro ao carregar empresas');
        }
    );
  }
}
